<template>
  <modal-wrapper
    ref="modalRef"
    :display-cancel-button="false"
    :show-header="false"
  >
    <h5>{{ t('metadataValidationModal.invalidDocumentIds') }}</h5>
    <ul>
      <li v-for="documentId in invalidDocumentIds" :key="documentId">
        {{ documentId }}
      </li>
    </ul>

    <div class="validation-hint">
      {{ t('metadataValidationModal.validationExplanation') }}
    </div>
  </modal-wrapper>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { useModalWrapper } from '../ModalWrapper';

  defineProps<{ invalidDocumentIds: string[] }>();

  const { t } = useI18n();

  const { modalRef, show, hide } = useModalWrapper();
  defineExpose({ show, hide });
</script>

<style scoped lang="scss">
  h5 {
    margin-top: 1rem;
  }
  .validation-hint {
    margin: 1rem 0;
  }
</style>
